import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import axiosInstance from "../AxiosBaseApi";
import { QRCodeCanvas } from "qrcode.react";

const SharePage = () => {
  const navigate = useNavigate();
  const [valueToCopy, setValueToCopy] = useState("");
  const [valueToLink, setValueToLink] = useState("");
  const [invitationCode, setInviteCode] = useState("");
  const [rechargeStatus, setRechargeStatus] = useState(0);

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(valueToLink)
      .then(() => {
        toast("Copy Successful", {
          autoClose: 800,

        });
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(valueToCopy)
      .then(() => {
        toast("Copy Successful", {
          autoClose: 800,        });
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=getuserinfo&user=${uid}`)

        .then((res) => {
          if (res.status === 200) {
            setInviteCode(res.data[0]?.usercode);
            setValueToCopy(res.data[0]?.usercode);
            setRechargeStatus(res.data[6]?.rechargestatus);
            setValueToLink(
              `${window.location.origin}/#/register?code=${res.data[0].usercode}`
            );
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    getUserData(token);
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          padding: 1,
          justifyContent: "space-between",
          alignItems: "center",
          background: "#3d3b6f",
        }}
      >
        <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
          <ChevronLeftIcon
            fontSize="medium"
            style={{
              color: "#fff",
              border: "1px solid #f2f3f5",
              borderRadius: 50,
            }}
          />
        </Box>
        <Typography variant="subtitle2" color="#fff">
          Share
        </Typography>
        <Box> </Box>
      </Box>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          mt: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "30px",
          minHeight: '200px'

        }}
      >
        {rechargeStatus === 0 ? (
          <>
            <Typography
              variant="h6"
              style={{ color: "#333", fontSize: "20px", fontWeight: "700" }}
            >
             Need A Recharge
            </Typography>{" "}
          </>
        ) : (
          <>
            {" "}
            {/* Invitation Code */}
            <Typography
              variant="h6"
              style={{ color: "#333", fontSize: "20px", fontWeight: "700" }}
            >
              Invitation Code
            </Typography>
            <Box
              style={{
                padding: "20px",
                width: "200px",
                backgroundColor: "#e9e9e9",
                borderRadius: "10px",
              }}
            >
              <QRCodeCanvas
                value={valueToLink}
                size={200}
                bgColor="#fff"
                fgColor="#000"
              />
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={1}
            >
              <Typography color="#e03e2d" variant="h5" fontWeight="bold">
                {invitationCode}
              </Typography>
              <IconButton onClick={handleCopy}>
                <ContentCopyIcon />
              </IconButton>
            </Box>
            {/* Invitation Link */}
            <Box
              display="flex"
              style={{ borderRadius: "50px", padding: "0 10px" }}
              backgroundColor="#e03e2d"
              justifyContent="center"
              alignItems="center"
              mt={2}
            >
              <Typography
                color="#fff"
                sx={{ wordBreak: "break-all", fontSize: "14px" }}
              >
                {valueToLink}
              </Typography>
              <IconButton onClick={handleCopyLink}>
                <ContentCopyIcon style={{ color: "#fff" }} />
              </IconButton>
            </Box>
          </>
        )}
      </Paper>
      <ToastContainer />
      {/* Instructions */}
      <Box textAlign="left" style={{ padding: "20px" }}>
        <Typography variant="body1" gutterBottom>
          <strong style={{ color: "#e03e2d" }}>
            1. Share your link or invitation code:
          </strong>{" "}
          Copy your exclusive recruitment link or invitation code screenshot.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong style={{ color: "#e03e2d" }}>2. Send to friends:</strong>{" "}
          Share the link to family or friends who need a job.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong style={{ color: "#e03e2d" }}>3. Get rewards:</strong> When
          someone signs up using your link, they become your A-level
          subordinate. When they upgrade to full-time employees, you get
          referral bonuses.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <strong style={{ color: "#e03e2d" }}>4. Warm Tips:</strong> Your level
          must be higher than or equal to your subordinates' level to receive
          rewards.
        </Typography>
      </Box>
    </div>
  );
};

export default SharePage;
